import { render, staticRenderFns } from "./captcha.vue?vue&type=template&id=05131d7f&scoped=true&"
import script from "./captcha.vue?vue&type=script&lang=js&"
export * from "./captcha.vue?vue&type=script&lang=js&"
import style0 from "./captcha.vue?vue&type=style&index=0&id=05131d7f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05131d7f",
  null
  
)

export default component.exports